/* SHANTAM global.js — drawers, ajax cart, reveals, product UX */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = document.body.getAttribute('data-money-format') || '₹{{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    amount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };

  /* ---------- Drawers ---------- */
  function openDrawer(name) {
    document.body.classList.add('drawer-open--' + name);
    var d = document.querySelector('[data-drawer="' + name + '"]');
    if (d) {
      var f = d.querySelector('button, a, input');
      if (f) f.focus({ preventScroll: true });
    }
  }
  function closeDrawers() {
    document.body.classList.remove('drawer-open--nav', 'drawer-open--cart');
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer-overlay')) {
      closeDrawers();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Sticky header shadow ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    }, { passive: true });
  }

  /* ---------- Scroll reveal ---------- */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduced && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- AJAX Cart ---------- */
  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    var body = document.querySelector('[data-cart-drawer-body]');
    var foot = document.querySelector('[data-cart-drawer-foot]');
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty"><p>' + (body.getAttribute('data-empty-text') || 'Your cart is empty. Take a breath — then explore the collection.') + '</p><a class="btn btn--ghost" href="/collections/all">' + (body.getAttribute('data-empty-cta') || 'Shop the collection') + '</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;

    var html = cart.items.map(function (item) {
      var img = item.image ? item.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_180x$1$2') : '';
      return '<div class="cart-line" data-line-key="' + item.key + '">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy" width="82" height="102">' : '<span></span>') +
        '<div><div class="cart-line__title">' + item.product_title + '</div>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-line__meta">' + item.variant_title + '</div>' : '') +
        '<div class="cart-line__meta">' + money(item.final_line_price) + '</div>' +
        '<div style="display:flex;gap:14px;align-items:center;margin-top:10px">' +
          '<span class="qty"><button type="button" data-qty-change="-1" aria-label="Decrease quantity">−</button>' +
          '<input type="number" value="' + item.quantity + '" min="0" data-qty-input aria-label="Quantity">' +
          '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button></span>' +
          '<button type="button" class="cart-remove" data-line-remove>Remove</button>' +
        '</div></div></div>';
    }).join('');
    body.innerHTML = html;

    var subtotal = document.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = money(cart.items_subtotal_price);
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var line = e.target.closest('.cart-line');
    if (!line || !line.closest('[data-drawer="cart"]')) return;
    var key = line.getAttribute('data-line-key');
    var input = line.querySelector('[data-qty-input]');
    if (e.target.closest('[data-qty-change]')) {
      var delta = parseInt(e.target.closest('[data-qty-change]').getAttribute('data-qty-change'), 10);
      changeLine(key, Math.max(0, (parseInt(input.value, 10) || 0) + delta));
    }
    if (e.target.closest('[data-line-remove]')) changeLine(key, 0);
  });

  /* Add-to-cart forms (product page + cards) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-adding-text') || 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () { return fetchCart(); })
      .then(function () {
        openDrawer('cart');
        if (btn) { btn.textContent = btn.getAttribute('data-added-text') || 'Added ✓'; setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1400); }
      })
      .catch(function (err) {
        if (btn) { btn.textContent = (err && err.description) ? 'Unavailable' : 'Try again'; setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1800); }
      });
  });

  fetchCart();

  /* ---------- Product gallery ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = gallery.querySelector('[data-gallery-main]');
    main.src = thumb.getAttribute('data-thumb');
    if (thumb.getAttribute('data-thumb-srcset')) main.srcset = thumb.getAttribute('data-thumb-srcset');
    gallery.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ---------- Variant selection ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (wrap) {
    var json = wrap.querySelector('[data-product-json]');
    if (!json) return;
    var product;
    try { product = JSON.parse(json.textContent); } catch (err) { return; }
    var idInput = wrap.querySelector('input[name="id"]');
    var priceEl = wrap.querySelector('[data-price]');
    var btn = wrap.querySelector('[data-add-btn]');

    function currentOptions() {
      var opts = [];
      wrap.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return opts;
    }
    function update() {
      var opts = currentOptions();
      var match = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) {
        priceEl.innerHTML = money(match.price) + (match.compare_at_price > match.price ? ' <s class="price--compare">' + money(match.compare_at_price) + '</s>' : '');
      }
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? (btn.getAttribute('data-default-text') || 'Add to cart') : (btn.getAttribute('data-soldout-text') || 'Sold out');
      }
    }
    wrap.addEventListener('change', function (e) { if (e.target.matches('[data-option-index] input')) update(); });
    update();
  });
})();
